<div class="modal-header">
    <h4 class="modal-title">Generar Contraseña</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="d-flex flex-column">
            <div class="form-group col-12">
                <label for="password">Contraseña Generada</label>
                <input type="text" class="form-control" id="password" formControlName="password" readonly>
            </div>
            <div class="custom-control custom-checkbox ml-3 mt-4">
                <input type="checkbox" class="custom-control-input" id="copied" formControlName="copied">
                <label class="custom-control-label" for="copied">&nbsp;He copiado la contraseña</label>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()"
        [attr.disabled]="(!form.value.copied) ? true : null">Aceptar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
</div>